import { useEffect, useRef } from 'react';

// A page that redirects to Stripe (window.location.href = ...) can be kept in
// the browser's back/forward cache with its JS state frozen. Returning with
// the Back button then restores a button stuck on "Opening checkout…" and
// disabled. `reset` clears that transient "in flight" state:
//  - on `pagehide` while entering bfcache (the redirect succeeded) so the
//    frozen copy is already clean,
//  - on `pageshow` (restore or any re-show), without gating on `persisted`
//    since browsers report it inconsistently, and
//  - as a fallback, `inFlightMs` after `inFlight` goes true and we're still
//    here — the redirect never took, so re-enable the button.
export default function useBfcacheReset(reset, inFlight, inFlightMs = 15000) {
  const ref = useRef(reset);
  ref.current = reset;

  useEffect(() => {
    const run = () => ref.current();
    const onHide = (e) => { if (e.persisted) run(); };
    window.addEventListener('pagehide', onHide);
    window.addEventListener('pageshow', run);
    return () => {
      window.removeEventListener('pagehide', onHide);
      window.removeEventListener('pageshow', run);
    };
  }, []);

  useEffect(() => {
    if (!inFlight) return undefined;
    const t = setTimeout(() => ref.current(), inFlightMs);
    return () => clearTimeout(t);
  }, [inFlight, inFlightMs]);
}
